export const secondsToHMS = (seconds: number, isWithoutHMS?: boolean) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = remainingSeconds.toString().padStart(2, "0");
  return isWithoutHMS
    ? `${
        hours > 0 ? `${formattedHours}:` : ""
      }${formattedMinutes}:${formattedSeconds}`
    : `${hours > 0 ? `${hours}ч ` : ""}${minutes > 0 ? `${minutes}мин ` : ""}${
        seconds > 0 ? `${remainingSeconds}сек` : ""
      }`;
};
